export default __webpack_public_path__ + "static/2-9a6507bd8c30eb904c0abf8cce460884.jpeg";